import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { CLIENT_DEBT } from 'api/query-keys.ts';
import type { TClientDebtRes } from 'api/swagger';

export const useGetClientDebt = (clientId: number) => {
  return useQuery<TClientDebtRes>({
    queryKey: [CLIENT_DEBT, clientId],
    queryFn: async () => {
      const { data } = await http.get<TClientDebtRes>(`/v1/clients/${clientId}/debt`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
